import { useEditor } from '../../state/editorStore';

/**
 * Safe-zone guide - draws placeholder chrome for YouTube Shorts or Instagram
 * Reels over the stage, so you can see where the platform's UI will cover the
 * video and keep captions clear of it. Pure view guide: pointer-events none,
 * not persisted and never burned into exports.
 */
export function SafeZoneOverlay() {
  const zone = useEditor((s) => s.safeZone);
  if (zone === 'off') return null;
  return (
    <div className={`safezone safezone-${zone}`} aria-hidden>
      {/* The safe rectangle: keep captions inside. Everything outside is dimmed. */}
      <div className="sz-safe" />
      {zone === 'youtube' ? <YouTubeChrome /> : <InstagramChrome />}
      <span className="safezone-tag">{zone === 'youtube' ? 'YouTube Shorts' : 'Instagram Reels'} safe zone</span>
    </div>
  );
}

/** Right-rail action buttons + bottom-left title block + progress bar. */
function YouTubeChrome() {
  return (
    <>
      <div className="sz-rail">
        {[0, 1, 2, 3, 4].map((i) => (
          <span className="sz-btn" key={i} />
        ))}
        <span className="sz-btn sz-btn-avatar" />
      </div>
      <div className="sz-meta">
        <span className="sz-line sz-line-lg" />
        <span className="sz-line" />
        <span className="sz-line sz-line-sm" />
      </div>
      <div className="sz-progress" />
    </>
  );
}

/** Right-rail actions + audio disc + bottom-left caption + bottom nav bar. */
function InstagramChrome() {
  return (
    <>
      <div className="sz-rail">
        {[0, 1, 2, 3].map((i) => (
          <span className="sz-btn" key={i} />
        ))}
        <span className="sz-btn sz-btn-disc" />
      </div>
      <div className="sz-meta">
        <span className="sz-line sz-line-lg" />
        <span className="sz-line" />
      </div>
      <div className="sz-nav">
        {[0, 1, 2, 3, 4].map((i) => (
          <span className="sz-nav-item" key={i} />
        ))}
      </div>
    </>
  );
}
